import auth from "./config/auth.json";
import apis from "./config/apis.json";
import { FetchClient } from "lib/auth/fetchClient";
import { Configuration, LogLevel } from "@azure/msal-browser";

export const msalAuthorities = {
  ad_b2c_signin_policy: `${auth.b2cTenant}/${auth.adb2cSignInPolicy}`,
  ad_b2c_form_completion_policy: `${auth.b2cTenant}/${auth.adb2cFormCompletionPolicy}`,
};

export const VERBOSE_MSAL_LOGGING_ENABLED = false;

const networkClient = new FetchClient();

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId: `${auth.clientId}`,
    authority: msalAuthorities.ad_b2c_signin_policy,
    knownAuthorities: auth.knownAuthorities,
    redirectUri: auth.redirectUri,
    postLogoutRedirectUri: auth.postLogoutRedirectUri,
    navigateToLoginRequestUrl: auth.navigateToLoginRequestUrl,
  },
  cache: {
    cacheLocation: "sessionStorage", // sessionStorage or localStorage, default is sessionStorage
  },
  system: {
    // `tokenRenewalOffsetSeconds`:
    //   The default value is 300 seconds (5 minutes).
    //   The value must be less than the access token lifetime defined in our custom policies (which is 300 seconds).
    //   Setting the value to 180 seconds (3 minutes) results in a token cache lifetime of 2 minutes (access token lifetime minus renewal offset).
    //   Access tokens older than 2 minutes will be renewed to ensure that the token does not expire when used.
    //   The 3 minute offset can help prevent clock skew (time difference between client and server) resulting in expired tokens being sent in requests.
    tokenRenewalOffsetSeconds: 180,
    networkClient,
    windowHashTimeout: 20000, // Applies just to popup calls - In milliseconds
    loadFrameTimeout: 20000, // Applies to both silent and popup calls - In milliseconds
    loggerOptions: {
      logLevel: VERBOSE_MSAL_LOGGING_ENABLED ? LogLevel.Verbose : LogLevel.Warning,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            // eslint-disable-next-line no-console
            console.info(message);
            return;
          case LogLevel.Verbose:
            // eslint-disable-next-line no-console
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
      piiLoggingEnabled: false
    },
  }
};

// Scopes you add here will be prompted for consent during login
// NOTE: It's only possible to retrieve scopes for a single resource at
// a time, as each resource requires its own access token.
export const loginRequest = { scopes: [apis.security.scope] };

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft-ppe.com/v1.0/me"
};
